import { LessonSample } from "./types";

// Sample files officers can download to try a feature. One per audio lesson,
// each written for its feature. Files live in client/public/academy/samples.
// Only the first exists today; add the others as their lessons are produced
// (see tools/academy/README.md for the ElevenLabs voice and naming).
export const SAMPLES = {
  narrativeRetailTheft: {
    file: "narrative-retail-theft.mp3",
    title: "Sample narrative dictation: retail theft",
    description:
      "A first-person officer dictation of a fictional shoplifting call: dispatch, the loss-prevention witness, the subject, recovered merchandise, and a cite-and-release.",
    length: "1 min 11 s",
    whatToExpect: [
      "A draft narrative in your preferred perspective, date and time format, with the store, the reporting party, and the subject named.",
      "A report score and a short list of suggestions. The dictation never gives your arrival time or the direction the subject left in, so expect a suggestion or placeholder about one of those.",
      "The transcription in the Transcription tab, synced to the audio.",
    ],
  },
} as const satisfies Record<string, LessonSample>;
